import { createFileRoute } from '@tanstack/react-router'
import { StockingAppleCreamLandingPage } from '../components/StockingAppleCreamLandingPage'
import { loadStockingAppleCream, stockingAppleCreamHead } from '../lib/stockingAppleCreamPage'

export const Route = createFileRoute('/stocking-apple-cream')({
  loader: loadStockingAppleCream,
  head: ({ loaderData }) => stockingAppleCreamHead(loaderData),
  component: Page,
})

function Page() {
  return <StockingAppleCreamLandingPage {...Route.useLoaderData()} />
}
